import { connect } from 'react-redux';

import { getLastReview } from 'src/store/reviews/selectors';
import LastReview from './LastReview';

const mapStateToProps = (state) => ({
  item: getLastReview(state),
});

export default connect(mapStateToProps)(LastReview);
